<template>
  <load-component v-if="!store.state.loaded"></load-component>
  <v-app v-else class="bg-white">
    <div class="content">
      <v-container>
        <v-carousel
            height="300"
            width="100%"
            show-arrows="hover"
            :hide-delimiters="true"
            :hide-delimiter-background="true"
            delimiter-icon="mdi-square"
            :cycle="true"
        >
          <v-carousel-item
              style="z-index: 2; position: relative"
              v-for="(image, index) in product.images" :key="index"
              :src=image
              :cover="false"
          >
          </v-carousel-item>
        </v-carousel>
        <v-card variant="flat">
          <v-card class="text-center">
            <v-card-title class="pre-subtitle">
              {{product.title}}

            </v-card-title>
            <v-card-text>
              {{product.price}} RUB<br>
            </v-card-text>
          </v-card>
        </v-card>

        <v-chip-group v-model="cart_product.size">
          <v-chip color="teal" rounded="lg" v-for="size in product.sizes" :key="size">
            {{ size }}
          </v-chip>
        </v-chip-group>
<!--        <v-sheet height="10px" class="bg-transparent"></v-sheet>-->
<!--        <v-row>-->
<!--          <v-col cols="5">-->

<!--          </v-col>-->
<!--          <v-col cols="5">-->

<!--          </v-col>-->
<!--        </v-row>-->
<!--        <v-sheet height="20px" class="bg-transparent"></v-sheet>-->
<!--        <div>Артикул: {{store.state.product.detail.articleNumber}}-->
<!--          <v-btn-->
<!--              size="x-small"-->
<!--              icon="mdi-content-copy"-->
<!--              rounded="lg"-->
<!--              variant="tonal"-->
<!--              color="teal"-->
<!--          >-->
<!--          </v-btn>-->
<!--        </div>-->
<!--        <div>ID товара: {{product_id}}-->
<!--          <v-btn-->
<!--              size="x-small"-->
<!--            icon="mdi-content-copy"-->
<!--            rounded="lg"-->
<!--            variant="tonal"-->
<!--            color="teal"-->
<!--        ></v-btn>-->
<!--        </div>-->
<!--        <div>Нравится: {{store.state.product.favoriteData.favoriteCount.count}}</div>-->
<!--        <v-sheet height="20px" class="bg-transparent"></v-sheet>-->

<!--        <a target="_blank" :href=store.state.product.shareInfo.shareLinkUrl>-->
<!--          <v-btn-->
<!--              prepend-icon="mdi-open-in-new"-->
<!--              color="teal"-->
<!--              variant="tonal"-->
<!--              rounded="lg"-->
<!--          >-->
<!--            Открыть на Poizon-->
<!--          </v-btn>-->
<!--        </a>-->
        <v-sheet height="100px" class="bg-transparent"></v-sheet>

      </v-container>
    </div>

    <v-bottom-navigation
        height="200px"
        base-color="#1A1C25"
        color="white"
    >
      <v-container>
        <v-row justify="center" no-gutters v-if="cart_product.count === 0">
          <v-col cols="12">
            <v-card
                @click="addToCart()"
                width="100%"
                height="48px"
                class="border-12 text-none"
                style="background: teal; font-size: 14px"
                variant="flat"
            >
              <v-card-item class="text-white text-center mt-1">
                <v-icon class="mb-1">
                  mdi-shopping-outline
                </v-icon>
                <b>
                  В корзину
                </b>
              </v-card-item>
            </v-card>
          </v-col>
        </v-row>
        <v-row class="text-center" justify="center" align="center" no-gutters v-else>
          <v-col cols="12">
            <v-btn
                :stacked="false"
                prepend-icon="mdi-open-in-new"
                width="100%"
                height="48px"
                class="border-12 text-none"
                style="background: white; font-size: 14px; color: teal"
                variant="outlined"
            >
              Открыть корзину
            </v-btn>
          </v-col>
        </v-row>
<!--          <v-spacer></v-spacer>-->
<!--          <v-col cols="2">-->
<!--            <v-card-->
<!--                @click="addProductCount()"-->
<!--                :stacked="false"-->
<!--                width="100%"-->
<!--                rounded="lg"-->
<!--                color="teal"-->
<!--                variant="tonal"-->
<!--            >-->
<!--              <v-card-item>-->
<!--                <v-icon>-->
<!--                  mdi-plus-->
<!--                </v-icon>-->
<!--              </v-card-item>-->
<!--            </v-card>-->
<!--          </v-col>-->
<!--          <v-col cols="1">-->
<!--            {{ order.count }}-->
<!--          </v-col>-->
<!--          <v-col cols="2">-->
<!--            <v-card-->

<!--                @click="removeProductCount()"-->
<!--                :stacked="false"-->
<!--                width="100%"-->
<!--                rounded="lg"-->
<!--                color="teal"-->
<!--                variant="tonal"-->
<!--            >-->
<!--              <v-card-item>-->
<!--                <v-icon>-->
<!--                  mdi-minus-->
<!--                </v-icon>-->
<!--              </v-card-item>-->
<!--            </v-card>-->
<!--          </v-col>-->
<!--        </v-row>-->
        <v-sheet height="20px" class="bg-transparent"></v-sheet>
      </v-container>

    </v-bottom-navigation>

    <v-snackbar
        style="margin-bottom: 100px"
        v-model="success_snackbar.show"
        :timeout="success_snackbar.timeout"
        color="#F3F3F3"
        rounded="lg"
        location="center"
        variant="flat"
    >
      <v-row justify="center" align="center" class="text-center">
        <v-col cols="auto">
          ✅ {{ success_snackbar.text }}
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="auto">
          <v-btn color="#3C3C3C"
                 rounded="lg"
                 icon="mdi-close"
                 class="text-none roboto-bold"
                 variant="flat"
                 size="x-small"
                 @click="success_snackbar.show = false"
          >
          </v-btn>
        </v-col>
      </v-row>
    </v-snackbar>
  </v-app>

</template>

<script>
import axios from "axios";
import store from "../store";
import LoadComponent from "@/components/LoadComponent.vue";

export default {
  name: "ProductPage",
  computed: {
    store() {
      return store
    },
  },
  components: {
    LoadComponent
  },
  data: () => ({
    success_snackbar: {
      text: null,
      timeout: 2000,
      show: false
    },
    product_id: null,
    cart_product: {
      size: "M",
      count: 0,
      id: 1
    },
    product: {
      title: null,
      price: 0,
      sizes: [],
      images: []
    },
  }),
  mounted() {
    window.Telegram.WebApp.BackButton.show()
    window.Telegram.WebApp.onEvent('backButtonClicked', () => {
      this.$router.push({ name: 'Home', });
    })
    this.$store.commit("setStateProperty", {
      property: "loaded", value: false
    })

    this.product_id = this.$route.query.product_id
    setTimeout(this.getProduct, 1000);
  },
  beforeUnmount() {
    this.$store.commit("setStateProperty", {
      property: "loaded", value: false
    })
    window.Telegram.WebApp.BackButton.hide()
    window.Telegram.WebApp.BackButton.offClick()
  },
  methods: {
    getProduct() {
      axios.get('api/v2/product', {
        params: {product_id: this.$route.query.product_id},
      }).then(response => {

        this.$store.commit("setStateProperty", {
          property: "loaded", value: true
        })

        this.product = response.data
      }).catch(error => {
        console.error(error);
      });
    },
    addToCart() {
      axios.post('api/v1/cart/add/', {
        user_id: store.state.user.id,
        product: {
          id: this.product.spu_id,
          price: this.product.price,
          title: this.product.title,
          logo_url: this.product.logo_url,
          size: this.product.sizes[this.cart_product.size],
          count: 1
        }
      }).then(() => {
        this.success_snackbar.text = "Товар успешно добавлен."
        this.success_snackbar.show = true

        if (!this.cart_product.count) {
          this.cart_product.count = 1
        }
        else {
          this.cart_product.count ++
        }
      }).catch(error => {
        console.error(error);
      });
    },
    removeProductCount() {
      if (this.order.count == 1) {
        this.order.count = 0
      }
      else {
        this.order.count --
      }
    }
  }
}
</script>

<style scoped>

@import url('https://fonts.cdnfonts.com/css/sf-pro-display');

html, body {
  font-family: 'SF Pro', sans-serif !important;
  color: black;
  background: white !important;
  touch-action: manipulation !important;
}

.pre-subtitle {
  white-space: pre-line !important;
}

</style>